import { FiSun, FiMoon } from 'react-icons/fi';
import { Button } from '@/components/atoms/ui/button';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

interface ThemeToggleProps {
  variant?: 'default' | 'board';
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  variant = 'default',
  className,
}) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  if (variant === 'board') {
    return (
      <button
        onClick={toggleTheme}
        className={cn(
          'theme-toggle-component p-3 hover:bg-gray-100 dark:hover:bg-white/20 transition-all rounded-xl',
          className
        )}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? (
          <FiSun className="h-5 w-5 text-gray-700 dark:text-[#929bc9]" />
        ) : (
          <FiMoon className="h-5 w-5 text-gray-700 dark:text-[#929bc9]" />
        )}
      </button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={cn('theme-toggle-component rounded-full hover:opacity-80', className)}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <FiSun className="h-5 w-5" />
      ) : (
        <FiMoon className="h-5 w-5" />
      )}
    </Button>
  );
};

